import React from "react";
import "./Profile.css";
import { useLocation, useNavigate } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";
import Preferences from "./Preferences";
import Password from "./Password";
import PermissionsTable from "../../components/PermissionsTable/PermissionsTable";
import { useTranslation } from "react-i18next";
import { getPermissionDisplayData, getUserRole, USER_ROLES } from "../../utils/UsersPermissions";

const ProfilePage = ({ path, profile }) => {
  const { t } = useTranslation("profile");
  const navigate = useNavigate();
  const location = useLocation();

  // Get permissions based on user role
  const permissions = getPermissionDisplayData(t);
  const userRole = getUserRole();
  const showPermissionsTab = userRole === USER_ROLES.VIEWER || userRole === USER_ROLES.MANAGER;

  const handleNavigateWithParams = (tab) => {
    navigate({
      pathname: location.pathname,
      search: `?path=${tab}`,
    });
  };

  const getTitle = () => {
    if (location.pathname === "/settings") {
      return t("profilePage.title.settings");
    } else {
      return t("profilePage.title.profile");
    }
  };

  const header_p =
    "box-border flex flex-row justify-center items-center p-2 gap-2 cursor-pointer w-fit h-10 rounded-sm m-0 font-inter font-normal font-medium text-base leading-6 text-[#5507CF]";

  return (
    <div className={"bg-#F8F8F8 w-full"}>
      <div
        className={
          "p-6 box-border w-full h-137 bg-white border-b-2 border-custom-purple"
        }
      >
        <h3
          className={
            "h-7 mt-4 font-inter font-bold text-2xl leading-7 text-[#292929]"
          }
        >
          {getTitle()}
        </h3>
        <div
          className={
            `box-border flex flex-row items-center p-0 gap-4 mt-7 ${showPermissionsTab ? 'w-[540px]' : 'w-[407px]'} h-10`
          }
        >
          <p
            className={header_p}
            onClick={() => handleNavigateWithParams("profile")}
            style={
              !path || path === "profile" || path === "editProfile"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("profilePage.tabs.personalInformation")}
          </p>
          <p
            className={header_p}
            onClick={() => handleNavigateWithParams("password")}
            style={
              path === "password"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("profilePage.tabs.password")}
          </p>
          <p
            className={header_p}
            onClick={() => handleNavigateWithParams("preferences")}
            style={
              path === "preferences"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("profilePage.tabs.preferences")}
          </p>
          {showPermissionsTab && (
            <p
              className={header_p}
              onClick={() => handleNavigateWithParams("permissions")}
              style={
                path === "permissions"
                  ? { borderBottom: "4px solid #5507CF" }
                  : { opacity: "0.6" }
              }
            >
              {t("profilePage.tabs.permissions")}
            </p>
          )}
        </div>
      </div>
      {!path || path === "profile" || path === "editProfile" ? (
        <PersonalInfo profile={profile} edit={path === "editProfile"} />
      ) : path === "preferences" ? (
        <Preferences />
      ) : path === "permissions" && showPermissionsTab ? (
        <PermissionsTable permissions={permissions} />
      ) : (
        <Password />
      )}
    </div>
  );
};

export default ProfilePage;
